import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: '登录',
        meta: {
            title: '锦法综合管理系统'
        },
        component: () => import('../views/Login.vue')
    },
    //下面路径映射分了children和菜单的分级无关，只是说明下面的所有路径映射都是再/首页中的，所以写道了childern里
    {
        path: '/',
        name: '首页',
        meta: {
            title: '锦法综合管理系统'
        },
        component: () => import('../views/HomeView.vue'),
        children: [
            {
                path: '/menu/menu',
                name: '菜单管理',
                component: () => import('../views/menu/menu.vue'),
            },
            {
                path: '/menu/promenu',
                name: '小程序菜单管理',
                component: () => import('../views/menu/promenu.vue'),
            },
            {
                path: '/menu/promenetwo',
                name: '小程序菜单管理',
                component: () => import('../views/menu/promenetwo.vue'),
            },
            {
                path: '/usermanage/userinfos',
                name: '账号管理',
                component: () => import('../views/usermanage/userinfos.vue'),
            },
            {
                path: '/role/role',
                name: '角色管理',
                component: () => import('../views/role/role.vue'),
            },
            {
                path: '/role/roletwo',
                name: '单位角色管理',
                component: () => import('../views/role/roletwo.vue'),
            },
            {
                path: '/configuration/configuration',
                name: '配置项管理',
                component: () => import('../views/configuration/configuration.vue'),
            },
            {
                path: '/configuration/unitconfiguration',
                name: '单位配置管理',
                component: () => import('../views/configuration/unitconfiguration.vue'),
            },
            {
                path: '/usermanage/usermanage',
                name: '管理员管理',
                component: () => import('../views/usermanage/usermanage.vue'),
            },
            {
                path: '/usermanage/usermanagetwo',
                name: '单位管理员列表',
                component: () => import('../views/usermanage/usermanagetwo.vue'),
            },
            {
                path: '/unit/unit',
                name: '单位管理',
                component: () => import('../views/role/unit.vue'),
            },
            {
                path: '/unit/unitDetail',
                name: '单位详情',
                meta:{isfan:true},
                component: () => import('../views/role/unitDetail.vue'),
            },
            {
                path: '/unit/unitinfos',
                name: '单位信息管理',
                component: () => import('../views/role/unitinfos.vue'),
            },
            {
                path: '/role/joblist',
                name: '功能模块管理',
                meta:{isfan:true},
                component: () => import('../views/role/joblist.vue'),
            },
            {
                path: '/canteen/canteen',
                name: '食堂管理',
                component: () => import('../views/canteen/canteen.vue'),
            },
            {
                path: '/canteen/cantconfig',
                name: '食堂配置管理',
                meta:{isfan:true},
                component: () => import('../views/canteen/cantconfig.vue'),
            },
            {
                path: '/canteen/canteendetail',
                name: '食堂详情',
                component: () => import('../views/canteen/canteendetail.vue'),
            },
            {
                path: '/userinfos/userlist',
                name: '人员管理',
                component: () => import('../views/userinfos/userlist.vue'),
            },
            {
                path: '/userinfos/importuser',
                name: '人员批量导入',
                meta:{isfan:true},
                component: () => import('../views/userinfos/importuser.vue'),
            },
            {
                path: '/userinfos/unimportuser',
                name: '人员批量导入失败记录',
                meta:{isfan:true},
                component: () => import('../views/userinfos/unimportuser.vue'),
            },
            {
                path: '/userinfos/group',
                name: '人员组管理',
                component: () => import('../views/userinfos/group.vue'),
            },
            {
                path: '/userinfos/department',
                name: '部门管理',
                component: () => import('../views/userinfos/department.vue'),
            },
            {
                path: '/userinfos/sign',
                name: '办公区域管理',
                component: () => import('../views/userinfos/officeArea.vue'),
            },
            {
                path: '/goodsmanage/iconinfos',
                name: '图标管理',
                component: () => import('../views/goodsmanage/iconinfos.vue'),
            },
            {
                path: '/goodsmanage/goodlist',
                name: '菜品管理',
                component: () => import('../views/goodsmanage/goodlist.vue'),
            },
            {
                path: '/goodsmanage/goodcat',
                name: '菜品分类管理',
                component: () => import('../views/goodsmanage/goodcat.vue'),
            },
            {
                path: '/goodsmanage/gooddetail',
                name: '菜品详情',
                meta:{isfan:true},
                component: () => import('../views/goodsmanage/gooddetail.vue'),
            },
            {
                path: '/goodsmanage/pricesign',
                name: '价标管理',
                component: () => import('../views/goodsmanage/pricesign.vue'),
            },
            {
                path: '/goodsmanage/priceusers',
                name: '价标关联用户',
                meta:{isfan:true},
                component: () => import('../views/goodsmanage/priceusers.vue'),
            },
            {
                path: '/post/postlist',
                name: '订单管理',
                meta:{keepAlive:true},
                component: () => import('../views/post/postlist.vue'),
            },
            {
                path: '/post/reservelist',
                name: '预定管理',
                component: () => import('../views/post/reservelist.vue'),
            },
            {
                path: '/post/postdetail',
                name: '订单详情',
                meta:{isfan:true},
                component: () => import('../views/post/postdetail.vue'),
            },
            {
                path: '/claim/claimconfig',
                name: '报销配置信息',
                component: () => import('../views/claim/claimconfig.vue'),
            },
            {
                path: '/claim/claimlist',
                name: '报销单列表',
                component: () => import('../views/claim/claimlist.vue'),
            },
            {
                path: '/registry/registrylist',
                name: '外勤登记列表',
                component: () => import('../views/registry/registrylist.vue'),
            },
            {
                path: '/information/informationlist',
                name: '频道信息列表',
                component: () => import('../views/information/informationlist.vue'),
            },
            {
                path: '/information/infocontext',
                name: '文章信息',
                component: () => import('../views/information/infocontextlist.vue'),
            },
            {
                path: '/information/infocontextitem',
                name: '文章信息',
                meta:{isfan:true},
                component: () => import('../views/information/infocontext.vue'),
            },
            {
                path: '/post/poststatistics',
                name: '数据分析',
                meta:{isfan:true},
                component: () => import('../views/post/poststatistics.vue'),
            },
            {
                path: '/information/infomationdetail',
                name: '文章信息详情',
                meta:{isfan:true},
                component: () => import('../views/information/infomationdetail.vue'),
            },
            {
                path: '/canteen/cantpics',
                name: '食堂轮播图',
                component: () => import('../views/canteen/cantpics.vue'),
            },
            {
                path: '/canteen/screenfull',
                name: '大屏轮播',
                component: () => import('../views/canteen/screenfull.vue'),
            },
            {
                path: '/question/questionlist',
                name: '问卷列表',
                component: () => import('../views/question/questionlist.vue'),
            },
            {
                path: '/question/result',
                name: '问卷结果',
                meta:{isfan:true},
                component: () => import('../views/question/result.vue'),
            },
            {
                path: '/question/cluster',
                name: '群组管理',
                component: () => import('../views/question/cluster.vue'),
            },
            {
                path: '/question/questioninfos',
                meta:{isfan:true},
                name: '题目列表',
                component: () => import('../views/question/questioninfos.vue'),
            },
            {
                path: '/question/questionadd',
                meta:{isfan:true},
                name: '新增题目',
                component: () => import('../views/question/questionadd.vue'),
            },
            {
                path: '/question/message',
                name: '留言列表',
                component: () => import('../views/question/message.vue'),
            },
            {
                path: '/invoice/invoicelist',
                name: '发票列表',
                component: () => import('../views/invoice/invoicelist.vue'),
            },
            {
                path: '/invoice/importinvoice',
                name: '发票信息校验',
                meta:{isfan:true},
                component: () => import('../views/invoice/importinvoice.vue'),
            },
            {
                path: '/invoice/invoiceinfo',
                name: '发票校验列表',
                component: () => import('../views/invoice/invoiceinfo.vue'),
            },
            {
                path: '/paypost/paylist',
                name: '微信扫码支付',
                meta:{keepAlive:true},
                component: () => import('../views/paypost/paylist.vue'),
            },
            {
                path: '/paypost/unitpaylist',
                name: '结算列表',
                meta:{keepAlive:true},
                component: () => import('../views/paypost/unitpaylist.vue'),
            },
            {
                path: '/paypost/accountlist',
                name: '订单结算处理',
                meta:{keepAlive:true},
                component: () => import('../views/paypost/accountlist.vue'),
            },
            {
                path: '/paypost/accountlistunit',
                name: '对账单列表',
                meta:{keepAlive:true},
                component: () => import('../views/paypost/accountlistunit.vue'),
            },
            {
                path: '/paypost/paypostdetail',
                name: '订单详情',
                meta:{isfan:true},
                component: () => import('../views/paypost/paypostdetail.vue'),
            },
            {
                path: '/paypost/servercost',
                name: '结算列表',
                meta:{keepAlive:true},
                component: () => import('../views/paypost/servercost.vue'),
            },
            {
                path: '/activity/activitylist',
                name: '工会活动',
                component: () => import('../views/activity/activitylist.vue'),
            },
            {
                path: '/activity/activeconfig',
                name: '活动配置',
                component: () => import('../views/activity/activeconfig.vue'),
            },
            {
                path: '/activity/addactdetail',
                name: '工会活动详情',
                meta:{isfan:true},
                component: () => import('../views/activity/addactdetail.vue'),
            },
            // {
            //     path: '/test/test',
            //     name: '测试页面',
            //     component: () => import('../views/test.vue'),
            // },
            {
                path: '/configuration/threeconfig',
                name: '第三方配置',
                component: () => import('../views/configuration/threeconfig.vue'),
            },
             // 短信验证信息
             {
                path: '/notehistory/notehistory',
                name: '短信验证信息',
                component: () => import('../views/notehistory/notehistory.vue'),
            },
        ]
    },
    {
        path: '/gzh/gzh',
        name: '登录',
        meta: {
            title: '锦法综合管理系统'
        },
        component: () => import('../views/gzhinfos/gzhinfo.vue')
    },
    {
        path: '/activity/actDetail',
        name: '活动详情',
        meta: {
            title: '活动详情'
        },
        component: () => import('../views/activity/actDetail.vue')
    },
]

const router = new VueRouter({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
